import Logo from "./Logo";

const LINKS = [
    { label: "Layanan", href: "#layanan" },
    { label: "Portofolio", href: "#portofolio" },
    { label: "Proses", href: "#proses" },
    { label: "Kontak", href: "#kontak" },
];

export default function Footer({ onNavigate }) {
    const year = new Date().getFullYear();
    return (
        <footer className="border-t border-white/10 py-14">
            <div className="mx-auto flex max-w-[1400px] flex-col gap-10 px-6 lg:flex-row lg:items-start lg:justify-between lg:px-10">
                <div className="max-w-xs">
                    <Logo />
                    <p className="mt-5 text-sm leading-relaxed text-zinc-500">
                        Aplikator kaca aluminium &amp; desain interior —
                        presisi di setiap garis dan sambungan.
                    </p>
                </div>

                <nav className="flex flex-col gap-3">
                    {LINKS.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            data-testid={`footer-link-${l.href.slice(1)}`}
                            onClick={(e) => {
                                e.preventDefault();
                                onNavigate(l.href);
                            }}
                            className="font-mono text-[11px] uppercase tracking-[0.22em] text-zinc-400 transition-colors duration-300 hover:text-gold"
                        >
                            {l.label}
                        </a>
                    ))}
                </nav>

                <div className="font-mono text-[10px] uppercase leading-loose tracking-[0.2em] text-zinc-600 lg:text-right">
                    <div>© {year} DARUNA</div>
                    <div>Kaca Aluminium &amp; Desain Interior</div>
                </div>
            </div>
        </footer>
    );
}
